module.exports = __webpack_public_path__ + "static/image-05@2x-76d1daf2abb1c6ceb3998c583aa14228.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/laboratoria/image-05@2x.jpg
// module id = 393
// module chunks = 3627797113349 20562973939449 33019919093843